<template>
<div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">

            <!--Portada General-->
            <!--INICIO SLIDE-1--> 
            <div class="swiper-slide fondoportada swiper-no-swiping" data-title="Elementos de contextualización / pág. 1">
                
                
                <div class="container d-flex justify-content-center h-100">
                    <div class="row align-self-center justify-content-center">                                
                        
                        <div></div>
                        
                        <div class="col-lg-4 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                            <div>
                                <h3 class="text-center mb-4 color4Ppal">Creado por:</h3>
                                <a href="https://www.itm.edu.co/" target="_blank"><img src="recursos/img/logo-itm-azul.png" class="img-fluid d-flex mx-auto mb-5 mb-lg-0" alt=""></a>
                                <!--<a href="https://www.itm.edu.co/" target="_blank"><img :src="require(`@/assets/RecursosITM/img/logo-itm-azul.png`)" class="img-fluid d-flex mx-auto mb-5 mb-lg-0" alt=""/></a>-->

                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12 col-12 offset-lg-2 d-flex justify-content-center mt-lg-5 bordelogoini ml-0 pl-0">
                            <a href="https://www.medellin.gov.co/" target="_blank"></a>                  
                            <img src="recursos/img/logo-alcaldia.png" class="img-fluid d-flex mx-auto pl-4" alt="">                 
                        </div>
                        <div class="row mt-5">
                            <div class="col-12">
                                <!-- <div class="d-none d-sm-none d-md-none d-lg-block mt-5"> -->
                                <div class="mt-5">
                                        <!--<img :src="require('../assets/RecursosITM/img/logo-alcaldia.png')" class="img-fluid" alt="">-->

                                    <img src="recursos/img/Linea-portada.png" class="img-fluid" alt="">
                                    <h3 class="mt-2 text-center pportada">www.itm.edu.co</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--INICIO SLIDE-1-->

            <!--INICIO SLIDE-2-->
            <div class="swiper-slide swiper-no-swiping portada" data-title="pág. 2">
                <div class="p-conten">
                    <img src="recursos/img/U2_INLIN_002.png" alt="" class="d-none d-md-block d-sm-none">
                    <img src="recursos/img/U2_INLIN_002_cel.png" alt="" class="d-block d-md-none">
                    <div class="row">
                        <div class="col-lg-8 offset-lg-2">
                            <h1 class="text-white">Unidad 2: Etapas del desarrollo</h1>
                            <hr class="lineaPortada">
                            <h2 class="text-white">Introducción a la Lingüística</h2>
                            <h3 class="text-white">Facultad de Artes y Humanidades</h3>
                        </div>
                    </div>
                    <h6 >Foto por <a href="https://unsplash.com/photos/HH4WBGNyltc" target="_blank" class="portadaEnlace">Jaredd Craig en Unsplash</a> </h6>
                </div>
            </div>

            <!--INICIO SLIDE-3-->
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="pág. 3">
                <div class="container-fluid">
                    <div class="row margen_principal">
                        <div class="col-12">
                            <h2>Elementos de contextualización</h2><br>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                            
                            <h3>Introducción</h3>
                            <div>
                                <p>El curso <span class="font-italic">Introducción a la Lingüística</span> del Instituto Tecnológico de Metropolitano (ITM) tiene un enfoque en las dos primeras unidades centrado en los procesos de adquisición y de desarrollo del lenguaje. Por ende, la presente unidad, denominada <span class="font-italic">Etapas del desarrollo</span>, busca realizar una contextualización general sobre la psicología evolutiva, las diversas concepciones que se han tenido sobre la infancia y la importancia de reconocer los cambios que ocurren en ella.</p> 
                                <p>Para tal propósito, la unidad se compone de los postulados cognitivos, socioculturales y filosóficos que han sido determinantes para explicar el modo como se realiza el desarrollo desde los primeros años del ser humano hasta la juventud. El conocimiento global de este proceso integrado por la adquisición y desarrollo faculta al estudiante de herramientas teóricas y metodológicas para la actuación en situaciones comunicativas, que comprenden estadios del desarrollo determinado como es el caso de los niños y niñas. También, proporciona un conocimiento de fundamentación sobre la actividad simbólica en los seres humanos, con el aumento de una consciencia crítica sobre las diferentes visiones que se tienen del desarrollo y un criterio propio sobre los procesos que han sido menos estudiados, como lo es la adquisición de la Lengua de Señas Colombiana (LSC) y sus problemas de índole psicolingüístico.</p>                                       
                            </div>                                                    
                            
                                <div class="Fondo1Ppal p-3 mt-4">
                                    <h3 class="text-white">Competencia</h3>
                                    <p class="text-white">Genera la apropiación conceptual de la evolución, tendencias y paradigmas en la lingüística, a partir de los principios epistemológicos e históricos para el estudio y comprensión de los fenómenos de la lengua. Con esto se logra construir herramientas metodológicas y estrategias que faciliten la resolución de problemas relacionados con los distintos niveles de la lengua y su contexto.</p>
                            </div>

                        </div>

                        <div class="col-lg-5 col-md-12 col-sm-12 col-12 offset-lg-1 mt-lg-0 mt-4">
                            <h3 class="text-left mt-4">Indicadores de competencia</h3>
                            
                            <div class="accordion" role="tablist">
                                <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-0" role="tab">
                                    <b-button block v-b-toggle.accordion-1 class="btnColapsable">Identifica</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                    <p>● Identifica, desde la teoría, las diferencias que se establecen entre los procesos del desarrollo del lenguaje en la infancia en contraste con otros estadios del desarrollo.<br>
                                       ● Identifica algunos componentes constituyentes en el proceso del desarrollo en el niño.</p>
                                    </b-card-body>
                                </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-0">
                                <b-card-header header-tag="header" class="p-0" role="tab">
                                    <b-button block v-b-toggle.accordion-2 class="btnColapsable">Clasifica</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                    <p>● Clasifica las variantes, estadios, etapas y manifestaciones que componen el desarrollo del lenguaje.</p>
                                    </b-card-body>
                                </b-collapse>
                                </b-card>
                            </div>

                            <div class="row d-flex justify-content-center">
                                <div class="col-md-5 col-xs-12 mt-5 d-flex align-items-center justify-content-center">
                                    <img src="recursos/img/GAVI/Aprendamos_Haciendo.png" class="img-fluid" alt="">
                                </div>
                                <div class="col-md-5 col-xs-12 Lineaizq1 mt-5">
                                    <div class="pl-2">
                                        <p>
                                            <span class="font-weight-bold">Tiempo de estudio recomendado</span> <br>
                                            Semanas 5, 6, 7 y 8
                                        </p>
                                        <p>
                                            <span class="font-weight-bold">Área de conocimiento</span> <br>
                                            Específica
                                        </p>
                                        <p>
                                            <span class="font-weight-bold">Programa</span><br>
                                            Interpretación y Traducción<br> Lenguaje de Señas Colombiana - Español
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <b-button v-b-modal.modal-redConceptos class="d-flex mx-auto mt-4 BtnPrincipal">Red de conceptos</b-button>
                        </div>

                        <ModalRed/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'
import {Controles} from '../assets/RecursosITM/js/Controles'

import ModalRed from '@/components/Modales'

export default {
  name: 'Home',
  data: function(){
      return{
        botonVerMas: {
            text: 'Ver mas +'
        },
        seen: false
        
      };
  },
  components: {
    ModalRed
  },
  methods: {
    cambiaTextoVerMas: function(){
        if(this.seen){
            this.seen=false;
            this.botonVerMas.text="Ver mas +"
        }else{
            this.seen=true;
            this.botonVerMas.text="Ver menos -"
        }
    }
  },
  mounted() {
        SwiperController(),
        document.title = this.$route.meta.title,
        Controles()
  }
}
</script>